import gql from 'graphql-tag';

/**
 * Data of the block project-financing ("Finanzierung"): the four financing fields of
 * `investmentDeductionAllowance`. Read through `Project.blocks.financing`, which checks the
 * block's read permission.
 */
export const PROJECT_FINANCING_FIELDS = gql`
  fragment projectFinancingFields on ProjectFinancingBlock {
    id
    number
    investmentDeductionAllowance {
      durationYears
      interestRatePercent
      fixedRateYears
      repaymentRatePercent
    }
  }
`;
